// extracted by mini-css-extract-plugin
module.exports = {"gridContainerLarge":"styles_gridContainerLarge__3_Ah9"};